import { isBefore, subDays } from 'date-fns';

import { campaignTypes } from 'constants/campaigns';

export const hasCampaignAllowedSetPrintProcess = (campaignDetail) => {
	if (!campaignDetail) return false;

	const { openLetterDate, type, letterPrintedDate } = campaignDetail;

	if (type === campaignTypes.UP_SELL) {
		return letterPrintedDate;
	}

	if (type === campaignTypes.X_SELL) {
		return letterPrintedDate && isBefore(subDays(new Date(), 1), new Date(openLetterDate));
	}

	return false;
};
